import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zqh3u776ct: FaireBrandEntity = {
  token: "b_zqh3u776ct",
  type: "brand",
  name: "Evergreen Apothecary",
  avatarUrl:
    "https://cdn.faire.com/fastly/c648e45670cbb67846df227c065d84bb287184c5b5ab20eb3c02908d0972c5f1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/72066a20dfb565ba9cb5981ef240a8cebf093f949d06c4629e2ea1055102dbd5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c648e45670cbb67846df227c065d84bb287184c5b5ab20eb3c02908d0972c5f1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72066a20dfb565ba9cb5981ef240a8cebf093f949d06c4629e2ea1055102dbd5.jpeg",
  location: "Mapleton, UT, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 125,
  isTopShop: true,
  isInsider: true,
  description:
    "Evergreen Apothecary is a storefront apothecary located in Utah. We take pride in our products being made in small batches. We only provide products that we have studied and have been formulated by an herbalist. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:49.205Z",
    importedBy: "entity-db-cli",
  },
};
